import { AppSettings } from '../AppSettings';
import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

@Injectable()
export class RpwService {
  constructor(private http: Http) { }


  reset(pwd: string) {
    let headers = new Headers();
    // this.createAuthorizationHeader(headers);
    headers.append('Content-Type', 'application/json');
    //    alert(dateOfBirth.split('/').join('-')); //1234/12/12
    let jsonS = {
      "_id": JSON.parse(localStorage.getItem('currentUser'))._id,
      "password": pwd

    };
    return this.http.post(AppSettings.SERVICE_ENDPOINT + '/api/rpw', jsonS, {
      headers: headers
    }).map((response: Response) => {
      // login successful if there's a jwt token in the response
      //      alert(response);
      alert('Lösenord har ändrats');

    });

  }


  createAuthorizationHeader(headers: Headers) {
    headers.append('Authorization', 'Basic ' +
      btoa('a20e6aca-ee83-44bc-8033-b41f3078c2b6:c199f9c8-0548-4be79655-7ef7d7bf9d20'));
  }

}


// WEBPACK FOOTER //
// ./src/app/resetPassword/rpw.service.ts